var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankYouPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1921_11670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2497 0C14.4672 0 0 14.4669 0 32.2491C0 50.0325 14.4672 64.5 32.2497 64.5C50.0319 64.5 64.4988 50.0322 64.4988 32.2491C64.4988 14.4669 50.0319 0 32.2497 0ZM32.2497 59.877C17.0163 59.877 4.62299 47.4831 4.62299 32.2491C4.62299 17.016 17.0163 4.62299 32.2497 4.62299C47.4828 4.62299 59.8758 17.016 59.8758 32.2491C59.8758 47.4831 47.4828 59.877 32.2497 59.877Z",
    fill: "url(#paint0_linear_1921_11670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8331 31.7099H33.6777V15.1435C33.6777 13.867 32.6431 12.832 31.3662 12.832C30.0896 12.832 29.0547 13.867 29.0547 15.1435V34.0214C29.0547 35.2979 30.0896 36.3329 31.3662 36.3329H48.8331C50.11 36.3329 51.1446 35.2979 51.1446 34.0214C51.1446 32.7448 50.1096 31.7099 48.8331 31.7099Z",
    fill: "#FE7D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1921_11670",
    x1: 32.2494,
    y1: 0,
    x2: 32.2494,
    y2: 64.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC683"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1921_11670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.5,
    height: 64.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouPending);
export default __webpack_public_path__ + "static/media/ThankYouPending.ac08ea6874699d0bab5b98aee9d05686.svg";
export { ForwardRef as ReactComponent };